import { render, staticRenderFns } from "./channelPermModal.vue?vue&type=template&id=093369ce&scoped=true&"
import script from "./channelPermModal.vue?vue&type=script&lang=js&"
export * from "./channelPermModal.vue?vue&type=script&lang=js&"
import style0 from "./channelPermModal.vue?vue&type=style&index=0&id=093369ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093369ce",
  null
  
)

export default component.exports